/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { Lab } from '../../models/lab';
import { UpdateLabDto } from '../../models/update-lab-dto';

export interface LabControllerUpdate$Params {
  labId: string;
      body: UpdateLabDto
}

export function labControllerUpdate(http: HttpClient, rootUrl: string, params: LabControllerUpdate$Params, context?: HttpContext): Observable<StrictHttpResponse<Lab>> {
  const rb = new RequestBuilder(rootUrl, labControllerUpdate.PATH, 'patch');
  if (params) {
    rb.path('labId', params.labId, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Lab>;
    })
  );
}

labControllerUpdate.PATH = '/lab/{labId}';
